module.exports = __webpack_public_path__ + "img/2010 winteressen 020.35badee4.jpg";